// source: icws_proto/icws_api_gateway/searching/base.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.InkCapture.ListOfWordIdsInLine', null, global);
goog.exportSymbol('proto.InkCapture.SearchResult', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.InkCapture.ListOfWordIdsInLine = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.InkCapture.ListOfWordIdsInLine.repeatedFields_, null);
};
goog.inherits(proto.InkCapture.ListOfWordIdsInLine, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.InkCapture.ListOfWordIdsInLine.displayName = 'proto.InkCapture.ListOfWordIdsInLine';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.InkCapture.SearchResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.InkCapture.SearchResult.repeatedFields_, null);
};
goog.inherits(proto.InkCapture.SearchResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.InkCapture.SearchResult.displayName = 'proto.InkCapture.SearchResult';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.InkCapture.ListOfWordIdsInLine.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.InkCapture.ListOfWordIdsInLine.prototype.toObject = function(opt_includeInstance) {
  return proto.InkCapture.ListOfWordIdsInLine.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.InkCapture.ListOfWordIdsInLine} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.InkCapture.ListOfWordIdsInLine.toObject = function(includeInstance, msg) {
  var f, obj = {
    idsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.InkCapture.ListOfWordIdsInLine}
 */
proto.InkCapture.ListOfWordIdsInLine.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.InkCapture.ListOfWordIdsInLine;
  return proto.InkCapture.ListOfWordIdsInLine.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.InkCapture.ListOfWordIdsInLine} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.InkCapture.ListOfWordIdsInLine}
 */
proto.InkCapture.ListOfWordIdsInLine.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.InkCapture.ListOfWordIdsInLine.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.InkCapture.ListOfWordIdsInLine.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.InkCapture.ListOfWordIdsInLine} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.InkCapture.ListOfWordIdsInLine.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string ids = 1;
 * @return {!Array<string>}
 */
proto.InkCapture.ListOfWordIdsInLine.prototype.getIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.InkCapture.ListOfWordIdsInLine} returns this
 */
proto.InkCapture.ListOfWordIdsInLine.prototype.setIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.InkCapture.ListOfWordIdsInLine} returns this
 */
proto.InkCapture.ListOfWordIdsInLine.prototype.addIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.InkCapture.ListOfWordIdsInLine} returns this
 */
proto.InkCapture.ListOfWordIdsInLine.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.InkCapture.SearchResult.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.InkCapture.SearchResult.prototype.toObject = function(opt_includeInstance) {
  return proto.InkCapture.SearchResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.InkCapture.SearchResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.InkCapture.SearchResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    documentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    scanId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    processedScanId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    blockId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    lineIdsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    wordsInLineList: jspb.Message.toObjectList(msg.getWordsInLineList(),
    proto.InkCapture.ListOfWordIdsInLine.toObject, includeInstance),
    order: jspb.Message.getFieldWithDefault(msg, 7, 0),
    score: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.InkCapture.SearchResult}
 */
proto.InkCapture.SearchResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.InkCapture.SearchResult;
  return proto.InkCapture.SearchResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.InkCapture.SearchResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.InkCapture.SearchResult}
 */
proto.InkCapture.SearchResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setScanId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProcessedScanId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBlockId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addLineIds(value);
      break;
    case 6:
      var value = new proto.InkCapture.ListOfWordIdsInLine;
      reader.readMessage(value,proto.InkCapture.ListOfWordIdsInLine.deserializeBinaryFromReader);
      msg.addWordsInLine(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrder(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.InkCapture.SearchResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.InkCapture.SearchResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.InkCapture.SearchResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.InkCapture.SearchResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocumentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getScanId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProcessedScanId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBlockId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLineIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getWordsInLineList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.InkCapture.ListOfWordIdsInLine.serializeBinaryToWriter
    );
  }
  f = message.getOrder();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeFloat(
      8,
      f
    );
  }
};


/**
 * optional string document_id = 1;
 * @return {string}
 */
proto.InkCapture.SearchResult.prototype.getDocumentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.InkCapture.SearchResult} returns this
 */
proto.InkCapture.SearchResult.prototype.setDocumentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string scan_id = 2;
 * @return {string}
 */
proto.InkCapture.SearchResult.prototype.getScanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.InkCapture.SearchResult} returns this
 */
proto.InkCapture.SearchResult.prototype.setScanId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string processed_scan_id = 3;
 * @return {string}
 */
proto.InkCapture.SearchResult.prototype.getProcessedScanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.InkCapture.SearchResult} returns this
 */
proto.InkCapture.SearchResult.prototype.setProcessedScanId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string block_id = 4;
 * @return {string}
 */
proto.InkCapture.SearchResult.prototype.getBlockId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.InkCapture.SearchResult} returns this
 */
proto.InkCapture.SearchResult.prototype.setBlockId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated string line_ids = 5;
 * @return {!Array<string>}
 */
proto.InkCapture.SearchResult.prototype.getLineIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.InkCapture.SearchResult} returns this
 */
proto.InkCapture.SearchResult.prototype.setLineIdsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.InkCapture.SearchResult} returns this
 */
proto.InkCapture.SearchResult.prototype.addLineIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.InkCapture.SearchResult} returns this
 */
proto.InkCapture.SearchResult.prototype.clearLineIdsList = function() {
  return this.setLineIdsList([]);
};


/**
 * repeated ListOfWordIdsInLine words_in_line = 6;
 * @return {!Array<!proto.InkCapture.ListOfWordIdsInLine>}
 */
proto.InkCapture.SearchResult.prototype.getWordsInLineList = function() {
  return /** @type{!Array<!proto.InkCapture.ListOfWordIdsInLine>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.InkCapture.ListOfWordIdsInLine, 6));
};


/**
 * @param {!Array<!proto.InkCapture.ListOfWordIdsInLine>} value
 * @return {!proto.InkCapture.SearchResult} returns this
*/
proto.InkCapture.SearchResult.prototype.setWordsInLineList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.InkCapture.ListOfWordIdsInLine=} opt_value
 * @param {number=} opt_index
 * @return {!proto.InkCapture.ListOfWordIdsInLine}
 */
proto.InkCapture.SearchResult.prototype.addWordsInLine = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.InkCapture.ListOfWordIdsInLine, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.InkCapture.SearchResult} returns this
 */
proto.InkCapture.SearchResult.prototype.clearWordsInLineList = function() {
  return this.setWordsInLineList([]);
};


/**
 * optional int32 order = 7;
 * @return {number}
 */
proto.InkCapture.SearchResult.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.InkCapture.SearchResult} returns this
 */
proto.InkCapture.SearchResult.prototype.setOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional float score = 8;
 * @return {number}
 */
proto.InkCapture.SearchResult.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.InkCapture.SearchResult} returns this
 */
proto.InkCapture.SearchResult.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


goog.object.extend(exports, proto.InkCapture);
